import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSignOutUser } from "../../store/Apis/UserApi";
import { useGetUserCredits } from "../../store/Apis/StripeApi";
import { useAppSelector } from "../../store/hooks";

const RechargeConfirmation = () => {
    const signOutUser = useSignOutUser();
    const getUserCredits=useGetUserCredits();
    const UserCredits=useAppSelector((s)=>s.User.UserCredits)
    useEffect(()=>{
      getUserCredits();
    },[])
    const handleLogOut=()=>{
        signOutUser({ IsAuthenticated: false });
    }

  return (
    <Modal className="DeleteModal" show={true} centered>
      <Modal.Body className={` border-0 rounded-3 px-0`}>
        <Box
          sx={{
            width: "100%",
            height: "283px",
            borderRadius: "26px",
            border: "1px solid  #76CFEB33",
            boxShadow: " 0px 4px 14.8px 0px #455A6447",
            background: "var(--M-background91)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-evenly",
            padding: "16px 43px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img
            className="Congratulations-img"
            style={{
              position: "absolute",
              top: " 0%",
              left: " 2%",
            }}
          />
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontWeight: "500",
              fontSize: "22px",
              lineHeight: "28px",
              color: "var(--Main_icons_color)",
              zIndex: "100",
            }}
          >
            Congratulations, Credits Recharged!
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "24px",
              textAlign: "center",
              color: "var(--Main_icons_color)",
              padding: "0px 55px",
              zIndex: "100",
            }}
          >
            You are now enjoying {(UserCredits?.credits??0)-(UserCredits?.usedCredits??0)} credits, Let’s bring your ideas to life.
          </Typography>
          <button
          className="btn-lets-go"
          onClick={handleLogOut}
          >
            Let’s go
          </button>
          <img
            className="Congratulations-img"
            style={{
              position: "absolute",
              bottom: " -21%",
              right: " 2%",
            }}
          />
        </Box>
      </Modal.Body>
    </Modal>
  );
};

export default RechargeConfirmation;
